import { render, staticRenderFns } from "./PopoverLimitCharacterSuggestion.vue?vue&type=template&id=21772900&scoped=true&"
import script from "./PopoverLimitCharacterSuggestion.vue?vue&type=script&lang=js&"
export * from "./PopoverLimitCharacterSuggestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21772900",
  null
  
)

export default component.exports